"use strict";

exports.__esModule = true;
exports.AggregateMetricSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MetricSelector = require("../../Metrics/MetricSelector");
var _Theme = require("../../Theme");
var _fetchSection = require("../../VIMANAMetrics/Sections/fetchSection");
var _utils = require("../common/MetricsFilters/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SingleMetricLabel = _styledComponents["default"].div.withConfig({
  displayName: "AggregateMetricSelector__SingleMetricLabel",
  componentId: "sc-1aawsfd-0"
})(["margin:0;font-size:", ";font-weight:700;padding:0 7px;height:24px;display:flex;align-items:center;"], (0, _Theme.val)("fontSizeSmall"));
var AggregateMetricSelector = exports.AggregateMetricSelector = function AggregateMetricSelector(_ref) {
  var metricChartSeries = _ref.metricChartSeries,
    selected = _ref.selected,
    onSelect = _ref.onSelect;
  var filterMetrics = metricChartSeries.map(function (d) {
    return d.metricName;
  });
  var metrics = (0, _fetchSection.fetchSection)("metrics").filter(function (metric) {
    return filterMetrics.includes(metric.name);
  });
  var metricItems = (0, _utils.flattenMetrics)(metrics);
  if (metricItems.length === 1) {
    return /*#__PURE__*/_react["default"].createElement(SingleMetricLabel, {
      "data-testid": "single-metric-label-test-id"
    }, metricItems[0].label);
  }
  return /*#__PURE__*/_react["default"].createElement(_MetricSelector.MetricSelector, {
    small: true,
    minimal: true,
    items: metricItems,
    selected: selected,
    onSelect: onSelect
  });
};